import './styles/main.less';
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store';
import AppConfig from './appConfig';
import ErrorPage from './components/Error/Error.vue';
import OdpInformation from './components/OdpInformation/OdpInformation.vue';
import OdpReader from './components/OdpReader/OdpReader.vue';
import MainTemplate from './components/Commons/MainTemplate.vue';
import FrequentlyAskedQuestionsConfirm from './components/FrequentlyAskedQuestions/FrequentlyAskedQuestionsConfirm.vue';
import TermsOfServiceConfirm from './components/TermsOfService/TermsOfServiceConfirm.vue';
import Settings from './components/Settings/SettingsTemplate.vue';
import Help from './components/Help/Help.vue';
import About1dService from './components/About1dService/About1dService.vue';
import OpenSourceLicense from './components/About1dService/OpenSourceLicense.vue';
import appConfig from './appConfig';

Vue.use(VueRouter);

const routes = [
    {
        path: '/', component: MainTemplate,
        redirect: '/OdpReader',
        children: [
            { path: 'OdpInformation', component: OdpInformation },
            { path: 'OdpReader', component: OdpReader },
            { path: 'Settings', component: Settings },
            { path: 'Help', component: Help },
            { path: 'FAQ', component: FrequentlyAskedQuestionsConfirm },
            { path: 'Terms', component: TermsOfServiceConfirm },
            { path: 'About1dService', component: About1dService },
            { path: 'OpenSourceLicense', component: OpenSourceLicense},
            { path: 'ErrorPage', component: ErrorPage },
        ],
    },
];
const router = new VueRouter({ mode: 'history', routes });

export interface Trace {
    LogLevel: string;
    Message: string;
    StackTrace: string | undefined;
    DateTime: Date;
    Source: string;
}

Vue.config.errorHandler = (err, vm, info) => {
    const url = appConfig.clientLogApiUrl;
    const errorInfo: Trace = {
        LogLevel: 'Error',
        Message: err.message,
        StackTrace: err.stack,
        DateTime: new Date(),
        Source: 'client',
    };
    console.error(err);
    console.error(vm);
    console.error(info);
    fetch(url, {
        headers: {
            'Accept': 'application/json, */*',
            'Content-type': 'application/json',
        },
        method: 'post',
        mode: 'no-cors',
        body: JSON.stringify(errorInfo),
    })
    .catch((responseErr) => console.error(responseErr));
    router.push('/ErrorPage');
};

AppConfig.init().then(
    (_) => {
        const app = new Vue({
            el: '#app',
            router,
            render: (h) => h(require('./components/app.vue')),
            store,
        });
    },
);
